module.exports = __webpack_public_path__ + "static/media/categories-logo-hubspot.6a8dd3b5.svg";